import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { tabs } from 'src/app/dummy/tabs';
import { PrintService } from 'src/app/services/print.service';
import { Environment } from 'src/app/stores/environment.store';
import { Report } from 'src/app/stores/report.store';
import { MappingService } from 'src/app/services/mapping.service';
import { ConvertService } from 'src/app/services/convert.service';
import { MatDialog } from '@angular/material';
import { InvoiceDialogComponent } from 'src/app/components/invoice-dialog/invoice-dialog.component';
import * as XLSX from 'xlsx';
import { SCHOOL } from 'src/app/dummy/config';
import { BaseStore } from 'src/app/stores/base.store';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-receipt-listings',
  templateUrl: './receipt-listings.component.html',
  styleUrls: ['./receipt-listings.component.scss']
})
export class ReceiptListingsComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  school = SCHOOL

  tabs = tabs.reportFilterBy;
  form: FormGroup;
  fromDate: AbstractControl;
  toDate: AbstractControl;
  cashier: AbstractControl;

  fromDateTime: any
  toDateTime: any

  type: string;

  cashierList = []

  constructor(
    private fb: FormBuilder,
    private ps: PrintService,
    public env: Environment,
    private route: ActivatedRoute,
    public store: Report,
    public dialog: MatDialog,
    public baseStore: BaseStore,
    public ds: DataService,

  ) { }

  print() {
    this.ps.print("#print", "a4");
  }

  fireEvent() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement, { raw: true });
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx');
  }

  async ngOnInit() {
    this.buildForm();
    this.route.params.forEach(async param => {
      this.type = param["id"];
      const fromDate = MappingService.fromDateFilter(this.type);
      const toDate = MappingService.toDateFilter(this.type);

      this.cashierList = await this.baseStore.fetchList(this.ds.cashierRef());

      this.form.patchValue({
        fromDate: fromDate,
        toDate: toDate
      });
      this.getList(fromDate, toDate, null, false);
    });



  }

  displayItem(item: any): string {
    return item ? item.full_name : item;
  }

  getList(fromDate, toDate, cashier, isFilter) {
    this.fromDateTime = fromDate;
    this.toDateTime = toDate;
    this.env.getUser(user => {
      if (user) {
        const userData = isFilter ? cashier : this.cashierList.find(m => m.key === user.key)
        this.cashier.patchValue(userData)
        this.store.fetchReceiptReportListing(ConvertService.toDateKey(fromDate), ConvertService.toDateKey(toDate), userData.key || null);
      }
    })
  }

  buildForm(): void {
    this.form = this.fb.group({
      fromDate: [null, Validators.required],
      toDate: [null, Validators.required],
      cashier: [null, Validators.compose([MappingService.validSelected.bind(this)])],

    });

    this.fromDate = this.form.controls["fromDate"];
    this.toDate = this.form.controls["toDate"];
    this.cashier = this.form.controls["cashier"];
  }

  _onPress(f: any) {
    if (this.form.valid) {
      const { fromDate, toDate, cashier } = f;
      this.getList(fromDate, toDate, cashier, true);
    }
  }

  _onPrint(item) {
    let dialogRef = this.dialog.open(InvoiceDialogComponent, {
      data: { studentKey: item.student.key, headerKey: item.headerRef },
      width: '90vw',
      height: '80vh',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

}
